import * as React from 'react';
import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {CoreDI, IEventManagerWithAsync, lazyInject, ScreenManager, ScreenParameters} from '@gongxigames/framework/core';
import {CheatPluginView} from '../../CheatPluginView';
import {CheatFiltersController} from './CheatFiltersController';
import {FiltersGroup} from './FiltersGroup';
import {ScrollComponent} from '../../components/ScrollContainer';

type CheatFiltersViewState = {
    width: number;
    height: number;
};

export class CheatFiltersView extends CheatPluginView<CheatFiltersController, {}, CheatFiltersViewState> {
    @lazyInject(CoreDI.IEventManagerWithAsync)
    protected eventManager!: IEventManagerWithAsync<GlobalEventsMap>;

    @lazyInject(CoreDI.ScreenManager)
    protected fullscreenManager!: ScreenManager;

    constructor(props: {}) {
        super(props as any);

        const {
            width,
            height
        } = this.fullscreenManager.getScreenState();

        this.state = {
            width,
            height
        };
    }

    public componentDidMount(): void {
        this.controller.onChanged = () => this.forceUpdate();
        this.eventManager.on('General.Screen.RESIZED', this.onResized.bind(this), this);
    }

    public componentWillUnmount(): void {
        this.controller.onChanged = () => {};
        this.eventManager.off('General.Screen.RESIZED', this);
    }

    protected onResized({width, height}: ScreenParameters): void {
        this.setState({width, height});
    }

    protected toggleFilter(filterName: string): void {
        this.controller.toggleFilter(filterName);
    }

    public render(): JSX.Element {
        const filterGroups: JSX.Element[] = [];
        const {filtersByGroup, selectedFilters} = this.controller;

        Object.keys(filtersByGroup).forEach(group => {
            const filters = filtersByGroup[group];

            filterGroups.push(
                <FiltersGroup
                    key={`${group}-FiltersGroup`}
                    name={group}
                    filters={filters.map(filter => filter.name)}
                    width={this.state.width - 500}
                    selectedFilters={selectedFilters} onSelect={this.toggleFilter.bind(this)}
                />
            );
        });

        return (
            <ScrollComponent y={80} boundsWidth={this.state.width - 20} boundsHeight={this.state.height - 400} scrollSize={80}>
                <FlexBoxComponent direction={'column'} gap={20} wrap={true} containerWidth={this.state.width - 20} containerHeight={this.state.height + 99999} >
                    {filterGroups}
                </FlexBoxComponent>
            </ScrollComponent>
        );
    }
}
